import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/lib/theme";

/**
 * Compact theme toggle. Drop it anywhere.
 * Variants:
 *   - "pill" (default) — outlined pill, best for headers/sidebars
 *   - "icon" — just the icon in a circle, best for fixed-position placements
 */
export default function ThemeToggle({ variant = "pill", className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  if (variant === "icon") {
    return (
      <button
        type="button"
        onClick={toggle}
        aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
        data-testid="theme-toggle-button"
        className={`w-9 h-9 rounded-full border border-[#272E2B] bg-[#0F1312] hover:border-[#4ADE80]/40 hover:bg-[#1C201E] flex items-center justify-center transition-colors ${className}`}
      >
        {isDark
          ? <Sun className="w-4 h-4 text-[#FBBF24]" />
          : <Moon className="w-4 h-4 text-[#60A5FA]" />}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      data-testid="theme-toggle-button"
      className={`flex items-center gap-1.5 text-xs text-[#A3ACA7] hover:text-white border border-[#272E2B] rounded-full px-3 py-1.5 hover:bg-[#272E2B] transition-colors ${className}`}
    >
      {isDark
        ? <><Sun className="w-3.5 h-3.5" /> <span className="hidden sm:inline">Light mode</span></>
        : <><Moon className="w-3.5 h-3.5" /> <span className="hidden sm:inline">Dark mode</span></>}
    </button>
  );
}
